import React from "react";
import { LeftOutlined } from "@ant-design/icons";
import "./BackButton.scss";

const BackButton = ({ onClick, text = "Volver", className = "" }) => {
  return (
    <div className={`blizu-back-button ${className}`} onClick={onClick}>
      <LeftOutlined style={{ fontSize: '12px' }} /> {text}
    </div>
  );
};

export default BackButton;
